import { combineReducers } from 'redux'

import app from '@services/store/reducers/app'

import landingZones from './landingZones'
import landingZoneTags from './landingZoneTags'
import landingZoneGroups from './landingZoneGroups'
import landingZoneServices from './landingZoneServices'
import landingZoneTeams from './landingZoneTeams'
import landingZoneMigration from './landingZoneMigration'

import firewallLogs from './firewallLogs'
import serviceHealth from './serviceHealth'

export const reducers = {
    app,
    landingZones,
    landingZoneTags,
    landingZoneGroups,
    landingZoneServices,
    landingZoneTeams,
    landingZoneMigration,
    firewallLogs,
    serviceHealth
}

const rootReducer = combineReducers(reducers)
export default rootReducer